import * as React from 'react';
import PropTypes from 'prop-types';
import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';

import OktaError from './OktaError';

const LoginCallback = ({ onAuthResume }) => {
  const { oktaAuth, authState } = useOktaAuth();
  const authStateReady = !authState.isPending;
  const navigate = useNavigate();

  React.useEffect(() => {
    if (onAuthResume && oktaAuth.isInteractionRequired?.()) {
      onAuthResume();
      return;
    }

    // if from login redirect
    if (oktaAuth.isLoginRedirect()) {
      oktaAuth.handleLoginRedirect().catch((err) => {
        console.log({ err });
        if (err.errorCode === 'access_denied') {
          if (localStorage) {
            localStorage.setItem('is_restricted', 1);
          }
          navigate('/restricted', {
            replace: true
          });
        }
      });
      // else redirect to login consume
    } else {
      const originalUri = oktaAuth.getOriginalUri();
      oktaAuth.removeOriginalUri();

      const { restoreOriginalUri } = oktaAuth.options;
      if (restoreOriginalUri) restoreOriginalUri(oktaAuth, originalUri);
    }
  }, [oktaAuth, oktaAuth.options.restoreOriginalUri]);

  if (authStateReady && authState.error) {
    return <OktaError error={authState.error} />;
  }

  return null;
};

LoginCallback.propTypes = {
  onAuthResume: PropTypes.func
};

export default LoginCallback;
